import { ComponentSelector, ComponentInjector } from '@atypon/ui-utils';
import CoreQuickSearch, {
    QuickSearchElements,
    QuickSearchSelectors,
    QuickSearchTexts,
    QuickSearchClassList
} from 'ui-core/widgets/quick-search/js/quick-search';

class Texts extends QuickSearchTexts { }

class ClassList extends QuickSearchClassList { }

class Selectors extends QuickSearchSelectors {
    quickSearchButton = '.actions__container .quick-search__button ';
    quickSearchContainer = '.quick-search';
}

class Elements extends QuickSearchElements {
}

interface QuickSearch {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class QuickSearch extends CoreQuickSearch {
    protected get defaultConfigs () {
        return {
            maxResults: 10,
            threshold: 2,
            debounce: 300,
            resultItem: {
                element: this.elementRenderer.bind(this),
                class: 'autoComplete__item'
            },
            searchEngine: (query, record) => {
                return record.highlight || record.label;
            },
        }
    }
}

export default QuickSearch;